$(function () {
    if ($('div#ConditionalUpdateCard').length > 0) {

        $("#SubmitButton").click(function (e) {

            e.preventDefault();
            e.stopImmediatePropagation();

            $(this).prop("disabled", true);

            var url = '';

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/WageEnhancement/EmployeeDetails/SubmitConditional/';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/WageEnhancement/EmployeeDetails/SubmitConditional/';
            }

            $.ajax({
                url: url + jsOper + '/' + jsAppId,
                method: 'POST',
                timeout: 0,
                success: function (res) {
                    console.log(res);
                    url = url.replace('SubmitConditional', 'CurrentData') + jsOper + '/' + jsEmployeeId;
                    window.location.href = url;
                },
                error: function (e) {
                    console.log(e);
                    url = url.replace('SubmitConditional', 'CurrentData') + jsOper + '/' + jsEmployeeId;
                    window.location.href = url;
                }
            });

            return false;
        });

        $("#WithdrawButton").click(function (e) {

            e.stopPropagation();
            e.preventDefault();

            $("#confirmModal").modal({
                'backdrop': 'static'
            });

            return false;
        });

        $("#WithdrawConfirmButton").click(function (e) {
            e.stopPropagation();
            e.preventDefault();

            $("#SubmitButton").prop("disabled", true);
            $("#WithdrawButton").prop("disabled", true);
            $("#WithdrawConfirmButton").prop("disabled", true);

            var url = '';

            if (location.href.indexOf('/en/') > 0) {
                url = location.href.split('/en/')[0] + '/en/WageEnhancement/EmployeeDetails/WithdrawConditional/';
            } else {
                url = location.href.split('/fr/')[0] + '/fr/WageEnhancement/EmployeeDetails/WithdrawConditional/';
            }

            $.ajax({
                url: url + jsOper + '/' + jsAppId,
                method: 'POST',
                success: function (res) {
                    url = url.replace('EmployeeDetails/WithdrawConditional', 'Employee/Registered') + jsOper;
                    window.location.href = url;
                },
                error: function (e) {
                    url = url.replace('EmployeeDetails/WithdrawConditional', 'Employee/Registered') + jsOper;
                    window.location.href = url;
                }
            });

            return false;
        });

    } // if ($('div#ConditionalUpdateCard').length > 0)
}); // $(function () {